import { useAuth } from '../hooks/useAuth';

const UserMenu = () => {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <div className="flex items-center gap-3">
      <span className="text-white text-sm font-medium">{user.username}</span>
      {user.role === 'admin' && (
        <span className="px-1.5 py-0.5 bg-yellow text-navy-dark text-[10px] font-bold rounded">
          ADMIN
        </span>
      )}
      <button
        onClick={logout}
        className="px-3 py-1.5 bg-white/10 hover:bg-white/20 text-white text-xs font-medium rounded-lg transition-colors"
      >
        Logout
      </button>
    </div>
  );
};

export default UserMenu;
